import { render } from "./ModificacionActivos.vue?vue&type=template&id=e0ad0078"
import script from "./ModificacionActivos.vue?vue&type=script&lang=js"
export * from "./ModificacionActivos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__